import { merge } from "lodash";
const liveSiteStyle = {
  palette: {},
  paletteConfig: {
    settingsActionColor: "#000000"
  },
  settingsStyles: {
    buttons: {
      borderRadius: "0px",
      textColor: "#FFFFFF"
    },
    dividers: {
      color: "#ededed",
      height: "12px"
    },
    icons: {
      color: "#000000"
    },
    inputs: {
      borderColor: "#000000",
      borderRadius: "0px",
      placeholderColor: "#646464"
    },
    text: {
      color: "#000000",
      fontFamily: "HelveticaNeue,Helvetica,Arial"
    },
    whitebox: {
      borderRadius: "0px",
      boxShadow: "0 8px 8px 0 rgba(22, 45, 61, 0.12), 0 3px 24px 0 rgba(22, 45, 61, 0.18)"
    },
    colorPaletteSelectedButton: {
      borderRadius: "0px"
    },
    smallButtons: {
      borderRadius: "0px"
    },
    bgColor: {
      backgroundColor: "rgba(0,0,0,.2)"
    },
    disabled: {
      backgroundColor: "#969696"
    },
    hover: {
      color: "#4D4D4D"
    }
  }
};
const withLiveSiteStyle = (theme) => merge({}, theme || {}, liveSiteStyle);
export {
  withLiveSiteStyle
};
//# sourceMappingURL=useLiveSiteStyle.js.map
